import React from 'react';
import PropTypes from 'prop-types';
import Message from '../../components/message/Message';
import {Link} from 'react-router-dom';
import {generateRoutePath} from 'epic-common/src/route';
import SquareButton from '../../components/squareButton/SquareButton';
import MetaTags from '../../components/common/MetaTags';


/**
 * 404 component.  Shown when page not found.
 *
 */
const Error404 = function Error404({staticContext}) {
    if (staticContext) {
        staticContext.status = 404;
    }
    return (
        <div className="error404 errorPages">
            <MetaTags meta={{title: '404'}} />
            <div className="content">
                <div className="error-header">
                    <h1>404</h1>
                    <h2>
                        <Message code="epic.unrealtournament.404.title1" />
                        <br />
                        <Message code="epic.unrealtournament.404.title2" />
                    </h2>
                </div>
                <p><Message code="epic.unrealtournament.404.subtitle" /></p>
                <div className="error-btn">
                    <Link className="btn" to={generateRoutePath('/')}>
                        <SquareButton config={{dark: true}}><Message code="epic.unrealtournament.404.return" /></SquareButton>
                    </Link>
                </div>
                
                
            </div>
        </div>
    );
};

Error404.propTypes = {
    staticContext: PropTypes.object
};

export default Error404;
